/** RFC 4122 v4 UUIDs (secure context: https or localhost). */
export const newId = (): string => globalThis.crypto.randomUUID();
